import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 4.08333C2.5 3.20888 3.20888 2.5 4.08333 2.5H25.9167C26.7911 2.5 27.5 3.20888 27.5 4.08333V25.9167C27.5 26.7911 26.7911 27.5 25.9167 27.5H4.08333C3.20888 27.5 2.5 26.7911 2.5 25.9167V4.08333Z",
      stroke: "currentColor",
      "stroke-width": "1.58333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.8687 11.1055V16.5057L10.451 11.1055H8.75V20H10.7811V14.5997L15.2115 20H16.8998V11.1055H14.8687Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19.8527 12.2109C20.589 12.2109 21.0841 11.7281 21.0841 11.0673C21.0841 10.4574 20.589 10 19.8527 10C19.1165 10 18.6214 10.4828 18.6214 11.1055C18.6214 11.7281 19.1165 12.2109 19.8527 12.2109ZM18.8626 20H20.8429V13.1639H18.8626V20Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }